module.exports = __webpack_public_path__ + "static/img/cus_03_pre.aecb0e27.jpg";